import React, { useState } from 'react';
import apiService from '../services/api';

const ApiTest: React.FC = () => {
  const [testResult, setTestResult] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const testFormResponsesAPI = async () => {
    setLoading(true);
    setTestResult('Testing form responses API...');
    
    try {
      console.log('Testing getAllFormResponses API...');
      const responses = await apiService.getAllFormResponses();
      console.log('API Response:', responses);
      
      if (responses && Array.isArray(responses)) {
        setTestResult(`✅ API Test Successful! Found ${responses.length} form responses.`);
      } else {
        setTestResult('⚠️ API returned unexpected data format.');
      }
    } catch (error: any) {
      console.error('API Test Error:', error);
      setTestResult(`❌ API Test Failed: ${error.message || 'Unknown error'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 border rounded">
      <h3 className="text-lg font-bold mb-2">API Test</h3>
      <button 
        onClick={testFormResponsesAPI}
        disabled={loading}
        className="btn btn-primary mb-2"
      >
        {loading ? 'Testing...' : 'Test Form Responses API'}
      </button>
      {testResult && (
        <div className="mt-2 p-2 bg-gray-100 rounded">
          <pre className="text-sm">{testResult}</pre>
        </div>
      )}
    </div>
  );
};

export default ApiTest; 